export default __webpack_public_path__ + "media/environment_friendly_banner_en.90813800.png";